<template>
  <div class="column is-12-mobile is-6-tablet is-4-desktop is-4-widescreen is-3-fullhd">
    <ValidationProvider v-slot="{ errors, valid }" rules="required" :name="label">
      <b-field :label="label" :message="errors" :type="{ 'is-danger': errors[0], 'is-success': valid }">
        <b-tooltip :label="tooltip" position="is-bottom">
          <select
            :id="id"
            v-model="auxValue"
            class="creditu-select"
            expanded>
            <option
              v-for="item in items"
              :key="item.value"
              :value="item.value">
              {{ item.text }}
            </option>
          </select>
        </b-tooltip>
      </b-field>
    </ValidationProvider>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: { ValidationProvider },
  props: ['id', 'items', 'value', 'label', 'tooltip'],
  data() {
    return {
      auxValue: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.auxValue = val;
      }
    },
    auxValue: {
      immediate: true,
      handler(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
<style scoped></style>
